<div class="modal-header">
  <h5 class="modal-title">{{ "TRANSLATE.CONFIRMATION" | translate }}</h5>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="close()"
    style="border: none; background: transparent; outline: none"
  >
    <span
      aria-hidden="true"
      style="font-size: 1.5rem; color: #6c757d; font-weight: bold"
      >&times;</span
    >
  </button>
</div>
<div class="modal-body">
  <p>
    {{ "TRANSLATE.ITEM_ADDED_SUCCESSFULLY" | translate }}
    {{ itemCount }} {{ "TRANSLATE.ITEMS_YOUR_CAR" | translate }}
  </p>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="navigateToProducts()">
    {{ "TRANSLATE.CONTINUE_SHOPPING" | translate }}
  </button>
  <button class="btn btn-primary" (click)="navigateToCart()">
    {{ "TRANSLATE.VIEW_CART" | translate }}
  </button>
</div>
